import React from "react";
import { motion } from "framer-motion";
import INFO from "../../data/user";
import "./styles/metrics.css";

const Metrics = () => {
	return (
		<section className="metrics-section">
			<div className="metrics-grid">
				{INFO.metrics.map((item, index) => (
					<motion.div
						key={index}
						className="metric-card"
						initial={{ opacity: 0, y: 16 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.4, delay: index * 0.1 }}
					>
						<span className="metric-value">{item.value}</span>
						<span className="metric-label">{item.label}</span>
						<span className="metric-subtext">{item.subtext}</span>
					</motion.div>
				))}
			</div>
		</section>
	);
};

export default Metrics;
